module.exports = __webpack_public_path__ + "src/assets/images/success-icon.9b2a91dd57bb53b983abbadd7e014271.svg";